import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Phone, MapPin, Building2, Lock, Edit2, Check, X, School, UserCircle, Users, Hash, Shield, Copy, Clock, AlertCircle } from 'lucide-react';
import { supabase } from '../../supabase/client';

const unitTypes = [
  { value: 'school', label: '学校', icon: School },
  { value: 'institution', label: '机构', icon: Building2 },
  { value: 'individual', label: '个体', icon: UserCircle },
];

const regionData: Record<string, string[]> = {
  '北京': ['北京市'], '上海': ['上海市'], '天津': ['天津市'], '重庆': ['重庆市'],
  '河北': ['石家庄', '唐山', '秦皇岛', '邯郸', '邢台', '保定', '张家口', '承德', '沧州', '廊坊', '衡水'],
  '山西': ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'],
  '辽宁': ['沈阳', '大连', '鞍山', '抚顺', '本溪', '丹东', '锦州', '营口', '阜新', '辽阳', '盘锦', '铁岭', '朝阳', '葫芦岛'],
  '吉林': ['长春', '吉林', '四平', '辽源', '通化', '白山', '松原', '白城', '延边'],
  '黑龙江': ['哈尔滨', '齐齐哈尔', '鸡西', '鹤岗', '双鸭山', '大庆', '伊春', '佳木斯', '七台河', '牡丹江', '黑河', '绥化', '大兴安岭'],
  '江苏': ['南京', '无锡', '徐州', '常州', '苏州', '南通', '连云港', '淮安', '盐城', '扬州', '镇江', '泰州', '宿迁'],
  '浙江': ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '舟山', '台州', '丽水'],
  '安徽': ['合肥', '芜湖', '蚌埠', '淮南', '马鞍山', '淮北', '铜陵', '安庆', '黄山', '滁州', '阜阳', '宿州', '六安', '亳州', '池州', '宣城'],
  '福建': ['福州', '厦门', '莆田', '三明', '泉州', '漳州', '南平', '龙岩', '宁德'],
  '江西': ['南昌', '景德镇', '萍乡', '九江', '新余', '鹰潭', '赣州', '吉安', '宜春', '抚州', '上饶'],
  '山东': ['济南', '青岛', '淄博', '枣庄', '东营', '烟台', '潍坊', '济宁', '泰安', '威海', '日照', '临沂', '德州', '聊城', '滨州', '菏泽'],
  '河南': ['郑州', '开封', '洛阳', '平顶山', '安阳', '鹤壁', '新乡', '焦作', '濮阳', '许昌', '漯河', '三门峡', '南阳', '商丘', '信阳', '周口', '驻马店'],
  '湖北': ['武汉', '黄石', '十堰', '宜昌', '襄阳', '鄂州', '荆门', '孝感', '荆州', '黄冈', '咸宁', '随州', '恩施'],
  '湖南': ['长沙', '株洲', '湘潭', '衡阳', '邵阳', '岳阳', '常德', '张家界', '益阳', '郴州', '永州', '怀化', '娄底', '湘西'],
  '广东': ['广州', '深圳', '珠海', '汕头', '佛山', '韶关', '湛江', '肇庆', '江门', '茂名', '惠州', '梅州', '汕尾', '河源', '阳江', '清远', '东莞', '中山', '潮州', '揭阳', '云浮'],
  '海南': ['海口', '三亚', '三沙', '儋州'],
  '四川': ['成都', '自贡', '攀枝花', '泸州', '德阳', '绵阳', '广元', '遂宁', '内江', '乐山', '南充', '眉山', '宜宾', '广安', '达州', '雅安', '巴中', '资阳', '阿坝', '甘孜', '凉山'],
  '贵州': ['贵阳', '六盘水', '遵义', '安顺', '毕节', '铜仁', '黔西南', '黔东南', '黔南'],
  '云南': ['昆明', '曲靖', '玉溪', '保山', '昭通', '丽江', '普洱', '临沧', '楚雄', '红河', '文山', '西双版纳', '大理', '德宏', '怒江', '迪庆'],
  '陕西': ['西安', '铜川', '宝鸡', '咸阳', '渭南', '延安', '汉中', '榆林', '安康', '商洛'],
  '甘肃': ['兰州', '嘉峪关', '金昌', '白银', '天水', '武威', '张掖', '平凉', '酒泉', '庆阳', '定西', '陇南', '临夏', '甘南'],
  '青海': ['西宁', '海东', '海北', '黄南', '海南', '果洛', '玉树', '海西'],
  '内蒙古': ['呼和浩特', '包头', '乌海', '赤峰', '通辽', '鄂尔多斯', '呼伦贝尔', '巴彦淖尔', '乌兰察布', '兴安', '锡林郭勒', '阿拉善'],
  '广西': ['南宁', '柳州', '桂林', '梧州', '北海', '防城港', '钦州', '贵港', '玉林', '百色', '贺州', '河池', '来宾', '崇左'],
  '西藏': ['拉萨', '日喀则', '昌都', '林芝', '山南', '那曲', '阿里'],
  '宁夏': ['银川', '石嘴山', '吴忠', '固原', '中卫'],
  '新疆': ['乌鲁木齐', '克拉玛依', '吐鲁番', '哈密', '昌吉', '博尔塔拉', '巴音郭楞', '阿克苏', '克孜勒苏', '喀什', '和田', '伊犁', '塔城', '阿勒泰'],
};

interface TeacherInfo {
  id: string;
  username: string;
  phone: string;
  region: string;
  unit_type: string;
  unit_name: string;
  bind_code: string;
  teacher_nickname: string;
  audit_status?: 'pending' | 'approved' | 'rejected';
  reject_reason?: string;
}

export default function TeacherBasicInfo() {
  const [teacherInfo, setTeacherInfo] = useState<TeacherInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    province: '',
    city: '',
    unitType: '',
    unitName: '',
    teacherNickname: '',
  });
  const [passwordForm, setPasswordForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [phoneForm, setPhoneForm] = useState({ newPhone: '', code: '' });
  const [countdown, setCountdown] = useState(0);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isEditingBindCode, setIsEditingBindCode] = useState(false);
  const [newBindCode, setNewBindCode] = useState('');
  const [bindCodeCopied, setBindCodeCopied] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadTeacherInfo();
    setupRealtimeSubscription();
  }, []);

  const loadTeacherInfo = async () => {
    setLoading(true);
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data: profile } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', user.id)
      .single();

    if (profile) {
      const regionParts = profile.region?.split(' ') || ['', ''];
      setTeacherInfo({
        id: profile.id,
        username: profile.username,
        phone: profile.phone,
        region: profile.region,
        unit_type: profile.unit_type,
        unit_name: profile.unit_name,
        bind_code: profile.bind_code || '',
        teacher_nickname: profile.teacher_nickname || '',
        audit_status: profile.audit_status || 'approved',
        reject_reason: profile.reject_reason || undefined,
      });
      setFormData({
        username: profile.username,
        province: regionParts[0] || '',
        city: regionParts[1] || '',
        unitType: profile.unit_type,
        unitName: profile.unit_name,
        teacherNickname: profile.teacher_nickname || '',
      });
    }
    setLoading(false);
  };

  // 设置 Realtime 订阅监听审核状态变化
  const setupRealtimeSubscription = () => {
    const channel = supabase
      .channel('basic-info-audit-status-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'profiles',
        },
        (payload) => {
          // 检查是否是当前用户的更新
          if (payload.new.id === teacherInfo?.id) {
            const newStatus = payload.new.audit_status;
            if (newStatus && newStatus !== teacherInfo.audit_status) {
              // 状态变化，刷新数据并提示
              loadTeacherInfo();
              if (newStatus === 'approved') {
                alert('恭喜！您的教师认证已通过审核，现在可以使用全部功能了');
              } else if (newStatus === 'rejected') {
                alert('审核未通过，请查看站内信了解详情');
              }
            }
          }
        }
      )
      .subscribe();

    // 组件卸载时清理订阅
    return () => {
      supabase.removeChannel(channel);
    };
  };

  const handleSave = async () => {
    if (!teacherInfo) return;

    const region = `${formData.province} ${formData.city}`.trim();
    const { error: profileError } = await supabase
      .from('profiles')
      .update({
        username: formData.username,
        region,
        unit_type: formData.unitType,
        unit_name: formData.unitName,
        teacher_nickname: formData.teacherNickname,
      })
      .eq('id', teacherInfo.id);

    if (profileError) {
      setMessage({ type: 'error', text: '保存失败: ' + profileError.message });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    const { error: userError } = await supabase.auth.updateUser({
      data: { username: formData.username }
    });

    if (userError) {
      setMessage({ type: 'error', text: '保存失败: ' + userError.message });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    const { error: accountError } = await supabase
      .from('user_accounts')
      .update({ username: formData.username })
      .eq('auth_user_id', teacherInfo.id);

    if (accountError) {
      setMessage({ type: 'error', text: '保存失败: ' + accountError.message });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }

    setMessage({ type: 'success', text: '保存成功' });
    setEditing(false);
    await loadTeacherInfo();
    window.dispatchEvent(new Event('user-info-updated'));
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  // 提交审核
  const handleSubmitAudit = async () => {
    if (!teacherInfo) return;
    
    // 验证必填字段
    if (!formData.province || !formData.city || !formData.unitType || !formData.unitName) {
      setMessage({ type: 'error', text: '请填写完整的资质信息（地区、单位性质、单位名称）' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }
    
    setSubmitting(true);
    try {
      const region = `${formData.province} ${formData.city}`.trim();
      const { error } = await supabase
        .from('profiles')
        .update({
          audit_status: 'pending',
          reject_reason: null, // 清空之前的拒绝原因
          region,
          unit_type: formData.unitType,
          unit_name: formData.unitName,
        })
        .eq('id', teacherInfo.id);
      
      if (error) throw error;
      
      setMessage({ type: 'success', text: '已提交审核，请耐心等待管理员审核' });
      await loadTeacherInfo(); // 刷新数据
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (err: any) {
      setMessage({ type: 'error', text: '提交失败：' + err.message });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChangePassword = async () => {
    if (!passwordForm.oldPassword) {
      setMessage({ type: 'error', text: '请输入原密码' });
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setMessage({ type: 'error', text: '两次密码输入不一致' });
      return;
    }
    if (passwordForm.newPassword.length < 6) {
      setMessage({ type: 'error', text: '密码至少6位' });
      return;
    }

    // 获取当前用户
    const { data: { user: currentUser } } = await supabase.auth.getUser();
    if (!currentUser || !currentUser.email) {
      setMessage({ type: 'error', text: '请先登录' });
      return;
    }

    // 验证原密码：尝试用原密码重新登录 Supabase Auth
    const { error: verifyError } = await supabase.auth.signInWithPassword({
      email: currentUser.email,
      password: passwordForm.oldPassword,
    });

    if (verifyError) {
      setMessage({ type: 'error', text: '原密码错误' });
      return;
    }

    // 原密码验证通过，更新为新密码
    const { error } = await supabase.auth.updateUser({
      password: passwordForm.newPassword,
    });

    if (error) {
      setMessage({ type: 'error', text: '修改失败: ' + error.message });
      return;
    }

    setMessage({ type: 'success', text: '密码修改成功' });
    setShowPasswordModal(false);
    setPasswordForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const sendCode = () => {
    if (!/^1[3-9]\d{9}$/.test(phoneForm.newPhone)) {
      setMessage({ type: 'error', text: '请输入正确的手机号' });
      return;
    }
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) clearInterval(timer);
        return c - 1;
      });
    }, 1000);
  };

  const handleChangePhone = async () => {
    if (!teacherInfo) return;
    if (phoneForm.code.length !== 6) {
      setMessage({ type: 'error', text: '请输入6位验证码' });
      return;
    }

    const { error } = await supabase
      .from('profiles')
      .update({ phone: phoneForm.newPhone })
      .eq('id', teacherInfo.id);

    if (error) {
      setMessage({ type: 'error', text: '修改失败' });
    } else {
      setMessage({ type: 'success', text: '手机号修改成功' });
      setShowPhoneModal(false);
      setPhoneForm({ newPhone: '', code: '' });
      loadTeacherInfo();
    }
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleSaveBindCode = async () => {
    if (!teacherInfo) return;
    if (newBindCode.length !== 3) {
      setMessage({ type: 'error', text: '绑定码必须为3位数字' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      return;
    }
    const { error } = await supabase
      .from('profiles')
      .update({ bind_code: newBindCode })
      .eq('id', teacherInfo.id);
    if (error) {
      setMessage({ type: 'error', text: '修改失败' });
    } else {
      setTeacherInfo({ ...teacherInfo, bind_code: newBindCode });
      setIsEditingBindCode(false);
      setNewBindCode('');
      setMessage({ type: 'success', text: '绑定码修改成功' });
    }
    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const copyBindCode = () => {
    if (teacherInfo?.bind_code) {
      navigator.clipboard.writeText(teacherInfo.bind_code);
      setBindCodeCopied(true);
      setTimeout(() => setBindCodeCopied(false), 2000);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
          <span className="text-gray-500 text-sm">加载中...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* 页面标题 */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">基本信息</h1>
          <p className="text-sm text-gray-500 mt-1">管理您的教师账户信息和绑定设置</p>
        </div>
        {!editing && (
          <button
            onClick={() => setEditing(true)}
            className="flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-all shadow-md hover:shadow-lg"
          >
            <Edit2 className="w-4 h-4" />
            编辑资料
          </button>
        )}
      </div>

      {/* 消息提示 */}
      <AnimatePresence>
        {message.text && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className={`p-4 rounded-xl flex items-center gap-3 ${
              message.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'
            }`}
          >
            {message.type === 'success' ? <Check className="w-5 h-5" /> : <X className="w-5 h-5" />}
            <span className="font-medium">{message.text}</span>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 审核状态横幅 */}
      {teacherInfo?.audit_status === 'pending' && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3"
        >
          <Clock className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-amber-800 font-medium">⏳ 您的教师认证正在审核中</p>
            <p className="text-amber-700 text-sm mt-1">预计24小时内完成审核，请耐心等待。审核期间您只能访问基本信息和站内信。</p>
          </div>
        </motion.div>
      )}

      {teacherInfo?.audit_status === 'rejected' && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-red-50 border border-red-200 rounded-xl p-4"
        >
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-red-800 font-medium">❌ 审核未通过</p>
              {teacherInfo.reject_reason && (
                <p className="text-red-700 text-sm mt-1">
                  <span className="font-medium">拒绝原因：</span>{teacherInfo.reject_reason}
                </p>
              )}
              <p className="text-gray-600 text-sm mt-2">请修改资料后点击下方"提交审核"按钮重新提交</p>
            </div>
          </div>
        </motion.div>
      )}

      {teacherInfo?.audit_status === 'approved' && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-start gap-3"
        >
          <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-green-800 font-medium">✅ 教师认证已通过</p>
            <p className="text-green-700 text-sm mt-1">您已获得完整权限，可以使用教师中心的所有功能</p>
          </div>
        </motion.div>
      )}

      {/* 绑定码卡片 - 醒目展示 */}
      <div className="bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 border border-amber-200 rounded-2xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-500 flex items-center justify-center shadow-md">
                <Users className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-gray-800">学员绑定信息</h2>
                <p className="text-sm text-gray-500">学员通过以下方式绑定到您名下</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* 绑定码 */}
            <div className="bg-white rounded-xl p-4 border border-amber-100 shadow-sm">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600 flex items-center gap-2">
                  <Hash className="w-4 h-4 text-amber-500" />
                  教师绑定码
                </span>
                {isEditingBindCode ? (
                  <div className="flex items-center gap-1">
                    <button
                      onClick={() => { setIsEditingBindCode(false); setNewBindCode(''); }}
                      className="px-2 py-1 text-xs text-gray-500 hover:bg-gray-100 rounded transition-colors"
                    >
                      取消
                    </button>
                    <button
                      onClick={handleSaveBindCode}
                      className="px-2 py-1 text-xs bg-amber-500 text-white rounded hover:bg-amber-600 transition-colors"
                    >
                      保存
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => { setNewBindCode(teacherInfo?.bind_code || ''); setIsEditingBindCode(true); }}
                    className="text-xs text-amber-600 hover:text-amber-700 hover:bg-amber-50 px-2 py-1 rounded transition-colors"
                  >
                    修改
                  </button>
                )}
              </div>
              {isEditingBindCode ? (
                <input
                  type="text"
                  value={newBindCode}
                  onChange={(e) => setNewBindCode(e.target.value.replace(/\D/g, '').slice(0, 3))}
                  placeholder="输入3位数字"
                  maxLength={3}
                  className="w-full px-3 py-2 border-2 border-amber-300 rounded-lg text-center text-2xl font-bold text-amber-600 tracking-[0.3em] focus:border-amber-500 focus:ring-2 focus:ring-amber-200 outline-none"
                  autoFocus
                />
              ) : (
                <div className="flex items-center gap-3">
                  <span className="text-3xl font-bold text-amber-600 tracking-[0.2em]">
                    {teacherInfo?.bind_code || '---'}
                  </span>
                  {teacherInfo?.bind_code && (
                    <button
                      onClick={copyBindCode}
                      className="p-1.5 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors"
                      title="复制绑定码"
                    >
                      {bindCodeCopied ? <Check className="w-4 h-4 text-green-500" /> : <Copy className="w-4 h-4" />}
                    </button>
                  )}
                </div>
              )}
              <p className="text-xs text-gray-400 mt-2">学员注册时输入此绑定码关联教师</p>
            </div>

            {/* 教师昵称 */}
            <div className="bg-white rounded-xl p-4 border border-amber-100 shadow-sm">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600 flex items-center gap-2">
                  <User className="w-4 h-4 text-amber-500" />
                  学员端显示名称
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xl font-semibold text-gray-800">
                  {teacherInfo?.teacher_nickname || teacherInfo?.username || '未设置'}
                </span>
                {!teacherInfo?.teacher_nickname && (
                  <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded">默认使用姓名</span>
                )}
              </div>
              <p className="text-xs text-gray-400 mt-2">学员在系统中看到的教师名称</p>
            </div>
          </div>
        </div>
      </div>

      {/* 个人资料卡片 */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
            <User className="w-4 h-4 text-purple-600" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800">个人资料</h2>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
            {/* 姓名 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">姓名</label>
              {editing ? (
                <input
                  type="text"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder="请输入姓名"
                />
              ) : (
                <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <User className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">{teacherInfo?.username}</span>
                </div>
              )}
            </div>

            {/* 昵称 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">
                昵称
                <span className="text-xs text-gray-400 font-normal ml-2">学员看到的名称</span>
              </label>
              {editing ? (
                <input
                  type="text"
                  value={formData.teacherNickname}
                  onChange={(e) => setFormData({ ...formData, teacherNickname: e.target.value })}
                  placeholder="默认为真实姓名"
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                />
              ) : (
                <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <User className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">
                    {teacherInfo?.teacher_nickname || teacherInfo?.username || '未设置'}
                  </span>
                  {!teacherInfo?.teacher_nickname && (
                    <span className="text-xs text-gray-400">(默认)</span>
                  )}
                </div>
              )}
            </div>

            {/* 手机号 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">手机号</label>
              <div className="flex items-center gap-2">
                <div className="flex-1 flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <Phone className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">
                    {teacherInfo?.phone?.includes('@') ? teacherInfo.phone.split('@')[0] : teacherInfo?.phone}
                  </span>
                </div>
                {!editing && (
                  <button
                    onClick={() => setShowPhoneModal(true)}
                    className="px-3 py-2.5 text-sm text-purple-600 hover:bg-purple-50 rounded-xl transition-colors font-medium"
                  >
                    更换
                  </button>
                )}
              </div>
            </div>

            {/* 所属地区 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">所属地区</label>
              {editing ? (
                <div className="grid grid-cols-2 gap-2">
                  <select
                    value={formData.province}
                    onChange={(e) => setFormData({ ...formData, province: e.target.value, city: '' })}
                    className="px-3 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  >
                    <option value="">选择省份</option>
                    {Object.keys(regionData).map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                  <select
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                    disabled={!formData.province}
                    className="px-3 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all disabled:bg-gray-100 disabled:text-gray-400"
                  >
                    <option value="">选择城市</option>
                    {formData.province && regionData[formData.province]?.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              ) : (
                <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <MapPin className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">{teacherInfo?.region || '未设置'}</span>
                </div>
              )}
            </div>

            {/* 单位性质 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">单位性质</label>
              {editing ? (
                <div className="flex gap-2">
                  {unitTypes.map(type => (
                    <button
                      key={type.value}
                      onClick={() => setFormData({ ...formData, unitType: type.value })}
                      className={`flex-1 py-2.5 rounded-xl text-sm font-medium transition-all flex items-center justify-center gap-1.5 border ${
                        formData.unitType === type.value
                          ? 'bg-purple-500 text-white border-purple-500 shadow-md'
                          : 'bg-white text-gray-600 border-gray-200 hover:border-purple-300 hover:bg-purple-50'
                      }`}
                    >
                      <type.icon className="w-4 h-4" />
                      {type.label}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <Building2 className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">
                    {unitTypes.find(t => t.value === teacherInfo?.unit_type)?.label || teacherInfo?.unit_type || '未设置'}
                  </span>
                </div>
              )}
            </div>

            {/* 单位名称 */}
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-gray-700">单位名称</label>
              {editing ? (
                <input
                  type="text"
                  value={formData.unitName}
                  onChange={(e) => setFormData({ ...formData, unitName: e.target.value })}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  placeholder="请输入单位名称"
                />
              ) : (
                <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 rounded-xl border border-gray-100">
                  <Building2 className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-800 font-medium">{teacherInfo?.unit_name || '未设置'}</span>
                </div>
              )}
            </div>
          </div>

          {/* 编辑操作按钮 */}
          <AnimatePresence>
            {editing && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="mt-6 pt-5 border-t border-gray-100 flex items-center justify-end gap-3"
              >
                <button
                  onClick={() => {
                    setEditing(false);
                    // 重置表单数据
                    if (teacherInfo) {
                      const regionParts = teacherInfo.region?.split(' ') || ['', ''];
                      setFormData({
                        username: teacherInfo.username,
                        province: regionParts[0] || '',
                        city: regionParts[1] || '',
                        unitType: teacherInfo.unit_type,
                        unitName: teacherInfo.unit_name,
                        teacherNickname: teacherInfo.teacher_nickname || '',
                      });
                    }
                  }}
                  className="px-5 py-2.5 text-gray-600 hover:bg-gray-100 rounded-xl transition-colors font-medium"
                >
                  取消
                </button>
                <button
                  onClick={handleSave}
                  className="flex items-center gap-2 px-6 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-all shadow-md hover:shadow-lg font-medium"
                >
                  <Check className="w-4 h-4" />
                  保存修改
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* 提交审核按钮（仅在 rejected 或 pending 状态下显示） */}
      {(teacherInfo?.audit_status === 'rejected' || teacherInfo?.audit_status === 'pending') && (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                {teacherInfo.audit_status === 'rejected' ? '重新提交审核' : '等待审核'}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {teacherInfo.audit_status === 'rejected' 
                  ? '修改资料后点击提交审核，管理员将重新审核您的申请'
                  : '您的申请正在审核中，请耐心等待'}
              </p>
            </div>
            {teacherInfo.audit_status === 'rejected' && (
              <button
                onClick={handleSubmitAudit}
                disabled={submitting}
                className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:bg-gray-400 transition-all shadow-md font-medium"
              >
                {submitting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                    提交中...
                  </>
                ) : (
                  <>
                    <Check className="w-4 h-4" />
                    提交审核
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      )}

      {/* 账号安全卡片 */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center">
            <Shield className="w-4 h-4 text-blue-600" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800">账号安全</h2>
        </div>
        <div className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                <Lock className="w-5 h-5 text-gray-600" />
              </div>
              <div>
                <p className="font-medium text-gray-800">登录密码</p>
                <p className="text-sm text-gray-500">定期更换密码可以保护账号安全</p>
              </div>
            </div>
            <button
              onClick={() => setShowPasswordModal(true)}
              className="px-4 py-2 text-purple-600 hover:bg-purple-50 rounded-xl transition-colors font-medium"
            >
              修改密码
            </button>
          </div>
        </div>
      </div>

      {/* 修改密码弹窗 */}
      <AnimatePresence>
        {showPasswordModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center">
                    <Lock className="w-5 h-5 text-purple-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">修改密码</h3>
                </div>
                <button onClick={() => setShowPasswordModal(false)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="space-y-4">
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">原密码</label>
                  <input
                    type="password"
                    placeholder="请输入原密码"
                    value={passwordForm.oldPassword}
                    onChange={(e) => setPasswordForm({ ...passwordForm, oldPassword: e.target.value })}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">新密码</label>
                  <input
                    type="password"
                    placeholder="请输入新密码（至少6位）"
                    value={passwordForm.newPassword}
                    onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">确认新密码</label>
                  <input
                    type="password"
                    placeholder="请再次输入新密码"
                    value={passwordForm.confirmPassword}
                    onChange={(e) => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  />
                </div>
              </div>
              {/* 弹窗内错误/成功提示 */}
              {message.text && (
                <div className={`mt-4 p-3 rounded-xl text-sm ${
                  message.type === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'
                }`}>
                  {message.type === 'error' ? '⚠️' : '✅'} {message.text}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setShowPasswordModal(false)}
                  className="flex-1 py-2.5 border border-gray-300 rounded-xl text-gray-600 hover:bg-gray-50 transition-colors font-medium"
                >
                  取消
                </button>
                <button
                  onClick={handleChangePassword}
                  className="flex-1 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors font-medium shadow-md"
                >
                  确认修改
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 更换手机号弹窗 */}
      <AnimatePresence>
        {showPhoneModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center">
                    <Phone className="w-5 h-5 text-purple-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">更换手机号</h3>
                </div>
                <button onClick={() => setShowPhoneModal(false)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="space-y-4">
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">新手机号</label>
                  <input
                    type="text"
                    placeholder="请输入新手机号"
                    value={phoneForm.newPhone}
                    onChange={(e) => setPhoneForm({ ...phoneForm, newPhone: e.target.value })}
                    maxLength={11}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">验证码</label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="请输入验证码"
                      value={phoneForm.code}
                      onChange={(e) => setPhoneForm({ ...phoneForm, code: e.target.value })}
                      maxLength={6}
                      className="flex-1 px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    />
                    <button
                      onClick={sendCode}
                      disabled={countdown > 0}
                      className="px-4 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 disabled:bg-gray-400 whitespace-nowrap transition-colors font-medium"
                    >
                      {countdown > 0 ? `${countdown}s` : '获取验证码'}
                    </button>
                  </div>
                </div>
              </div>
              {/* 弹窗内错误/成功提示 */}
              {message.text && (
                <div className={`mt-4 p-3 rounded-xl text-sm ${
                  message.type === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'
                }`}>
                  {message.type === 'error' ? '⚠️' : '✅'} {message.text}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setShowPhoneModal(false)}
                  className="flex-1 py-2.5 border border-gray-300 rounded-xl text-gray-600 hover:bg-gray-50 transition-colors font-medium"
                >
                  取消
                </button>
                <button
                  onClick={handleChangePhone}
                  className="flex-1 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors font-medium shadow-md"
                >
                  确认更换
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
